import { render, staticRenderFns } from "./icons-s3.vue?vue&type=template&id=598060fe&scoped=true"
import script from "./icons-s3.vue?vue&type=script&lang=ts"
export * from "./icons-s3.vue?vue&type=script&lang=ts"
import style0 from "./icons-s3.vue?vue&type=style&index=0&id=598060fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598060fe",
  null
  
)

export default component.exports